import { API_BASE_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type {
  FileDetailResponse,
  FileListResponse,
  FileStatItem,
  ReplaceFilePayload,
} from './types';

export async function fetchFilesList(qs: string): Promise<FileListResponse> {
  return apiFetch<FileListResponse>(
    `/v3/cascade-tracing/documents/my-documents?${qs}`,
    {},
    API_BASE_URL,
  );
}

export async function fetchFileDetail(
  documentId: string,
): Promise<FileDetailResponse> {
  return apiFetch<FileDetailResponse>(
    `/v3/cascade-tracing/documents/${documentId}/purchase-order`,
    {},
    API_BASE_URL,
  );
}

export async function fetchFileStatistics(): Promise<FileStatItem[]> {
  return apiFetch<FileStatItem[]>(
    '/v3/cascade-tracing/documents/statistics',
    {},
    API_BASE_URL,
  );
}

export async function deleteFiles(ids: string[]): Promise<void> {
  return apiFetch<void>(
    '/v3/cascade-tracing/documents',
    { method: 'DELETE', body: JSON.stringify({ ids }) },
    API_BASE_URL,
  );
}

export async function replaceFile(
  payload: ReplaceFilePayload,
): Promise<unknown> {
  return apiFetch<unknown>(
    '/v3/cascade-tracing/documents/replace',
    { method: 'POST', body: JSON.stringify(payload) },
    API_BASE_URL,
  );
}
